import type { ViewProps } from './layout';

export type SurfaceVariant = 'default' | 'subtle' | 'raised' | 'outline';

export interface SurfaceProps extends Omit<ViewProps, 'bg' | 'borderColor' | 'borderWidth'> {
  variant?: SurfaceVariant;
}
